// extracted by mini-css-extract-plugin
export default {"maincontainer":"ManageModel_maincontainer__kxevI","heading":"ManageModel_heading__Sa2I9","formSpace":"ManageModel_formSpace__Xwoej","tableCover":"ManageModel_tableCover__uy2La"};